import type { ProjectionOperation } from '../OperationTypes.js'
import { NoConfig } from '../OperationTypes.js'
import { DateTime } from 'luxon'
import { granularityLabel } from './DateGranularity.js'

const createProjectionOperation = <T extends string, TConfig>(op: ProjectionOperation<T, TConfig>) => op
export const projectMonthYear = createProjectionOperation({
  key: 'project-month-year',
  type: 'projection',
  label: 'Month/Year',
  applicableTo: ['datetime'],

  apply: (sample, field) => {
    const raw = field.getter(sample)
    if (!raw) return { label: 'Unknown', value: 'undefined' }

    const date = DateTime.fromISO(String(raw))
    if (!date.isValid) return { label: 'Invalid Date', value: 'invalid' }

    const value = date.toFormat('yyyy-MM')
    return { value, label: granularityLabel(value, 'month') }
  },
  config: NoConfig
})

export const projectQuarter = createProjectionOperation({
  key: 'project-quarter',
  type: 'projection',
  label: 'Quarter (e.g. Q1 2024)',
  applicableTo: ['datetime'],

  apply: (sample, field) => {
    const raw = field.getter(sample)
    if (!raw) return { label: 'Unknown', value: 'undefined' }

    const date = DateTime.fromISO(String(raw))
    if (!date.isValid) return { label: 'Invalid Date', value: 'invalid' }

    const value = `${date.year}-Q${date.quarter}`
    return { value, label: granularityLabel(value, 'quarter') }
  },
  config: NoConfig
})

export const projectYear = createProjectionOperation({
  key: 'project-year',
  type: 'projection',
  label: 'Year',
  applicableTo: ['datetime'],

  apply: (sample, field) => {
    const raw = field.getter(sample)
    if (!raw) return { label: 'Unknown', value: 'undefined' }

    const date = DateTime.fromISO(String(raw))
    if (!date.isValid) return { label: 'Invalid Date', value: 'invalid' }

    return {
      value: String(date.year),
      label: String(date.year)
    }
  },
  config: NoConfig
})
